<template>
	<div class="content">
		<div class="section">
			<div class="section-tit">고객검색</div>
			<div class="search-top">
				<div class="left">
					<label class="input-label">고객명</label>
					<input class="form-control sm" type="text" v-model="searchOptions_.clientName" @keyup.enter="btnSearch" />
					<label class="input-label">연락처</label>
					<input class="form-control sm" type="text" v-model="searchOptions_.clientMobile" @keyup.enter="btnSearch" />
					<label class="input-label">찾는물건금액</label>
					<input
						class="form-control xsm"
						type="number"
						placeholder="억"
						v-model="searchOptions_.clientMoneyS"
						@keyup.enter="btnSearch"
					/>
					<span class="search-top--text">~</span>
					<input
						class="form-control xsm"
						type="number"
						placeholder="억"
						v-model="searchOptions_.clientMoneyE"
						@keyup.enter="btnSearch"
					/>
					<label class="input-label">관리등급</label>
					<label class="input-checkbox">
						<input type="checkbox" v-model="st" @change="btnStOption" />
						<span class="checkbox"></span>
						<span class="text">전체</span>
					</label>
					<label class="input-checkbox">
						<input type="checkbox" v-model="searchOptions_.clientLevel" :value="'A'" />
						<span class="checkbox"></span>
						<span class="text">A</span>
					</label>
					<label class="input-checkbox">
						<input type="checkbox" v-model="searchOptions_.clientLevel" :value="'B'" />
						<span class="checkbox"></span>
						<span class="text">B</span>
					</label>
					<label class="input-checkbox">
						<input type="checkbox" v-model="searchOptions_.clientLevel" :value="'C'" />
						<span class="checkbox"></span>
						<span class="text">C</span>
					</label>
					<label class="input-label" v-if="!isPartnerGuest">담당자</label>
					<!-- <select class="form-control select sm">
						<option>전체</option>
					</select> -->

					<select v-if="!isPartnerGuest" v-model="searchOptions_.mId" class="form-control select sm">
						<option value="" selected>전체</option>
						<option v-for="c in memFilterList" :key="'clienttype_' + c.ind_cfg_uid" :value="c.mem_uid">
							{{ c.mem_name }} {{ c.mem_rank_name }}
						</option>
					</select>
				</div>
				<div class="right">
					<button type="button" class="btn btn-primary" @click="btnSearch">검색</button>
				</div>
			</div>
		</div>
		<div class="section">
			<div class="tab-btn">
				<button type="button" class="btn tab" v-bind:class="{ active: !tabUid && menuType == 1 }" @click="changeMenu(1)">
					고객관리
				</button>
				<button type="button" class="btn tab" v-if="!isPartnerGuest" v-bind:class="{ active: !tabUid && menuType == 2 }" @click="changeMenu(2)">
					미관리
				</button>
				<button type="button" class="btn tab" v-if="!isPartnerGuest" v-bind:class="{ active: !tabUid && menuType == 3 }" @click="changeMenu(3)">
					부동산
				</button>
				<button type="button" class="btn tab" v-if="!isPartnerGuest" v-bind:class="{ active: !tabUid && menuType == 4 }" @click="changeMenu(4)">
					블랙리스트
				</button>
				<div class="right">
					<button type="button" class="btn btn-sm btn-secondary" v-if="isMaster" @click="goHoldAdmin">자동보류 제외 관리</button>
					<button type="button" class="btn btn-sm btn-secondary" @click="btnOpenRegister">신규등록</button>
					<!-- <input class="form-control" type="text" placeholder="연락처" /> -->
					<!-- <button type="button" class="btn btn-sm btn-secondary">검색</button> -->
				</div>
			</div>
			<!-- CS 내 탭: 직원마다 만드는 폴더(카톡 채팅방 폴더처럼). 위 고객구분 탭의 하위가 아니라 옆으로 고르는
			     보기라서, 탭을 고르면 고객구분과 무관하게 그 탭에 담긴 고객이 전부 나온다. DESIGN.md 의 2차
			     필터 규칙대로 탭바와 같은 모양을 쓰지 않고 칩으로 한 단 낮춘다. -->
			<div class="ua-tabs">
				<span class="ua-tabs--label">내 탭</span>
				<button type="button" class="btn ua-tabs--chip" v-bind:class="{ on: !tabUid }" @click="pickTab(null)">
					전체
				</button>
				<button
					v-for="t in myTabs"
					:key="'mytab_' + t.tab_uid"
					type="button"
					class="btn ua-tabs--chip"
					v-bind:class="{ on: tabUid === t.tab_uid }"
					@click="pickTab(t.tab_uid)"
				>
					{{ t.tab_name }}
					<span class="ua-tabs--cnt">{{ t.cnt }}</span>
				</button>
				<button type="button" class="btn ua-tabs--edit" @click="openTabEdit">탭 관리</button>
				<span v-if="!myTabs.length" class="ua-tabs--hint">탭 관리에서 집중관리, 네이버유입 같은 나만의 탭을 만들 수 있습니다.</span>
			</div>
			<!-- CY 열람범위: 팀장은 팀 고객까지 보는데, 팀이 지정되지 않았으면 본인 고객만 보인다(조용히 넓히지 않는다). -->
			<p v-if="listScope && listScope.teamUnassigned" class="ua-scope-note">
				팀이 지정되지 않아 본인 담당 고객만 보입니다. 시스템관리 &gt; 팀 관리에서 팀을 지정하면 팀원 고객까지 볼 수 있습니다.
			</p>
			<div class="tab-con">
				<div class="ua-bar">
					<div class="ua-bar--left">
						<span class="ua-bar--sel">선택 {{ selected.length }}명</span>
						<select v-model="assignTabUid" class="form-control select sm" :disabled="!myTabs.length">
							<option value="">탭 선택</option>
							<option v-for="t in myTabs" :key="'asg_' + t.tab_uid" :value="t.tab_uid">{{ t.tab_name }}</option>
						</select>
						<button type="button" class="btn btn-sm btn-secondary" :disabled="busy" @click="btnAssign(true)">탭에 넣기</button>
						<button type="button" class="btn btn-sm btn-secondary" :disabled="busy" @click="btnAssign(false)">탭에서 빼기</button>
					</div>
					<div class="ua-bar--right">
						<span class="ua-bar--label">정렬</span>
						<div class="ua-seg">
							<button type="button" class="btn" v-bind:class="{ on: sort === 'reg' }" @click="changeSort('reg')">등록순</button>
							<button type="button" class="btn" v-bind:class="{ on: sort === 'hold' }" @click="changeSort('hold')">
								자동보류 임박순
							</button>
						</div>
					</div>
				</div>
				<div class="table-wrap">
					<table class="table click ua-list">
						<tr>
							<th>
								<label class="input-checkbox">
									<input type="checkbox" :checked="allChecked" @change="toggleAll($event.target.checked)" />
									<span class="checkbox"></span>
								</label>
							</th>
							<th>고정</th>
							<th>번호</th>
							<th>담당자</th>
							<th>관리등급</th>
							<th>고객분류</th>
							<th>고객명</th>
							<th>휴대폰</th>
							<th>찾는물건금액</th>
							<th>보유현금</th>
							<th>찾는위치</th>
							<th>등록일시</th>
							<th>최근상담</th>
							<th :title="'마지막 상담이력 작성일 + ' + holdCfg.days + '일'">자동보류</th>
						</tr>
						<tr
							v-for="(item, idx) in itemList"
							:key="'useradmin_' + item.client_uid"
							v-bind:class="{ 'ua-pinned': item.pinned }"
							@click="btnOnDetail(item.client_uid, idx)"
						>
							<td @click.stop>
								<label class="input-checkbox">
									<input type="checkbox" v-model="selected" :value="item.client_uid" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td @click.stop>
								<button
									type="button"
									class="btn ua-pin"
									v-bind:class="{ on: item.pinned }"
									:title="item.pinned ? '고정 해제' : '맨 위에 고정'"
									@click="togglePin(item)"
								>
									<b-icon-pin-angle-fill v-if="item.pinned" />
									<b-icon-pin-angle v-else />
								</button>
							</td>
							<td>{{ item.client_uid }}</td>
							<td>{{ item.mem_name }} {{ item.mem_rank_name }}</td>
							<td>{{ item.mgr_level }}</td>
							<td>{{ $CLIENT_TYPE[item.client_type] }}</td>
							<td>
								{{ item.name }}
								<span v-for="tid in knownTabs(item)" :key="'rt_' + item.client_uid + '_' + tid" class="ua-chip">{{ tabName(tid) }}</span>
							</td>
							<td>{{ item.mobile }}</td>
							<td>{{ item.find_money_s }}억 ~ {{ item.find_money_e }}억</td>
							<td>{{ item.having_money }}억</td>
							<td>{{ item.find_area }}</td>
							<td>{{ item.reg_date }}</td>
							<td>{{ item.assign_date == '0000-00-00 00:00' ? '' : item.assign_date }}</td>
							<td class="ua-dday-cell">
								<span class="ua-dday" v-bind:class="'is-' + badge(item).level" :title="badge(item).title">
									{{ badge(item).text }}
								</span>
								<span v-if="badge(item).sub" class="ua-dday--sub">{{ badge(item).sub }}</span>
							</td>
						</tr>
						<tr v-if="loaded && !itemList.length">
							<td colspan="14" class="ua-empty">
								{{ emptyText }}
							</td>
						</tr>
					</table>
				</div>

				<ul class="pagination b-pagination pagination-sm" v-if="pageData != null && pageData.list.length">
					<li class="page-item" v-bind:class="{ disabled: 1 == page }">
						<button type="button" class="page-link" @click="getItemList(1)">
							<b-icon-chevron-double-left />
						</button>
					</li>

					<li class="page-item" v-bind:class="{ disabled: pageData.first == null }">
						<button type="button" class="page-link" @click="pageData.first !== null ? getItemList(pageData.first) : ''">
							<b-icon-chevron-left />
						</button>
					</li>
					<li
						v-for="pg in pageData.list"
						v-bind:key="'pg_' + pg"
						class="page-item"
						v-bind:class="{ active: pageData.currentPage == pg }"
					>
						<button type="button" class="page-link" @click="getItemList(pg)">{{ pg }}</button>
					</li>
					<li class="page-item" v-bind:class="{ disabled: pageData.end == null }">
						<button type="button" class="page-link" @click="pageData.end !== null ? getItemList(pageData.end) : ''">
							<b-icon-chevron-right />
						</button>
					</li>

					<li class="page-item" v-bind:class="{ disabled: pageData.totalPage == page }">
						<button type="button" class="page-link" @click="getItemList(pageData.totalPage)">
							<b-icon-chevron-double-right />
						</button>
					</li>
				</ul>
			</div>
		</div>
	</div>

	<div v-if="isRegisterPopupShow" class="popup-wrap">
		<div class="dim" @click="isRegisterPopupShow = false"></div>
		<div class="popup sm">
			<div class="popup-tit">
				매수고객정보
				<button type="button" class="btn btn-close" @click="isRegisterPopupShow = false"><b-icon-x-lg /></button>
			</div>
			<div class="popup-con">
				<table class="table type-input">
					<tr v-if="!isPartnerGuest">
						<th>담당자</th>
						<td>
							<select v-model="addInfo.mgrUid" class="form-control select">
								<option value="" selected>전체</option>
								<option v-for="c in memList" :key="'clienttype_' + c.ind_cfg_uid" :value="c.mem_uid">
									{{ c.mem_name }} {{ c.mem_rank_name }}
								</option>
							</select>
						</td>
					</tr>
					<tr>
						<th>고객구분</th>
						<td>
							<label class="input-checkbox">
								<input type="radio" name="radio1" v-model="addInfo.clientType" :value="'manage'" />
								<span class="checkbox radio"></span>
								<span class="text">관리</span>
							</label>
							<label class="input-checkbox" v-if="!isPartnerGuest">
								<input type="radio" name="radio1" v-model="addInfo.clientType" :value="'none'" />
								<span class="checkbox radio"></span>
								<span class="text">미관리</span>
							</label>
							<label class="input-checkbox" v-if="!isPartnerGuest">
								<input type="radio" name="radio1" v-model="addInfo.clientType" :value="'property'" />
								<span class="checkbox radio"></span>
								<span class="text">부동산</span>
							</label>
							<label class="input-checkbox" v-if="!isPartnerGuest">
								<input type="radio" name="radio1" v-model="addInfo.clientType" :value="'black'" />
								<span class="checkbox radio"></span>
								<span class="text">블랙</span>
							</label>
							<label class="input-checkbox">
								<input type="radio" name="radio1" v-model="addInfo.clientType" :value="'contract'" />
								<span class="checkbox radio"></span>
								<span class="text">계약</span>
							</label>
						</td>
					</tr>
					<tr>
						<th>관리등급</th>
						<td>
							<label class="input-checkbox">
								<input type="radio" name="radio2" v-model="addInfo.mgrLevel" :value="'A'" />
								<span class="checkbox radio"></span>
								<span class="text">A</span>
							</label>
							<label class="input-checkbox">
								<input type="radio" name="radio2" v-model="addInfo.mgrLevel" :value="'B'" />
								<span class="checkbox radio"></span>
								<span class="text">B</span>
							</label>
							<label class="input-checkbox">
								<input type="radio" name="radio2" v-model="addInfo.mgrLevel" :value="'C'" />
								<span class="checkbox radio"></span>
								<span class="text">C</span>
							</label>
						</td>
					</tr>
					<tr>
						<th>고객명</th>
						<td>
							<div class="form-wrap">
								<input class="form-control" type="text" v-model="addInfo.clientName" />
							</div>
						</td>
					</tr>
					<tr v-if="!isPartnerGuest">
						<th>연락처1</th>
						<td>
							<div class="form-wrap">
								<input class="form-control" type="tel" placeholder="연락처" maxlength="20" :value="addInfo.clientMobile1" @input="onPhoneInput($event, 'clientMobile1')" />
								<input class="form-control" type="text" placeholder="메모" v-model="addInfo.clientMobileMemo1" />
							</div>
						</td>
					</tr>
					<tr v-if="!isPartnerGuest">
						<th>연락처2</th>
						<td>
							<div class="form-wrap">
								<input class="form-control" type="tel" placeholder="연락처" maxlength="20" :value="addInfo.clientMobile2" @input="onPhoneInput($event, 'clientMobile2')" />
								<input class="form-control" type="text" placeholder="메모" v-model="addInfo.clientMobileMemo2" />
							</div>
						</td>
					</tr>
					<tr>
						<th>이메일</th>
						<td>
							<div class="form-wrap">
								<input class="form-control" type="email" v-model="addInfo.clientEmail" />
							</div>
						</td>
					</tr>
					<tr>
						<th>찾는물건금액</th>
						<td>
							<div class="form-wrap">
								<input class="form-control" type="number" v-model="addInfo.findMoneyS" />
								<span class="form-text">억 ~ </span>
								<input class="form-control" type="number" v-model="addInfo.findMoneyE" />
								<span class="form-text">억</span>
							</div>
						</td>
					</tr>
					<tr>
						<th>보유현금</th>
						<td>
							<div class="form-wrap">
								<input class="form-control" type="number" v-model="addInfo.havingMoney" />
								<span class="form-text">억</span>
							</div>
						</td>
					</tr>
					<tr>
						<th>찾는위치</th>
						<td>
							<div class="form-wrap">
								<input class="form-control" type="text" v-model="addInfo.findArea" />
							</div>
						</td>
					</tr>
					<tr>
						<th>관리메모</th>
						<td>
							<div class="form-wrap">
								<textarea class="form-control" v-model="addInfo.clientMemo"></textarea>
							</div>
						</td>
					</tr>
				</table>
				<div class="btn-wrap">
					<button type="button" class="btn btn-sm btn-secondary" @click="isRegisterPopupShow = false">취소</button>
					<button type="button" class="btn btn-sm btn-primary" @click="btnUserAdd">저장</button>
				</div>
			</div>
		</div>
	</div>

	<!-- CS 탭 관리: 만들기·이름 바꾸기·순서·삭제. 탭은 만든 사람에게만 보인다. -->
	<div v-if="isTabEditShow" class="popup-wrap">
		<div class="dim" @click="closeTabEdit"></div>
		<div class="popup sm">
			<div class="popup-tit">
				내 탭 관리
				<button type="button" class="btn btn-close" @click="closeTabEdit"><b-icon-x-lg /></button>
			</div>
			<div class="popup-con">
				<p class="ua-help">탭은 나에게만 보입니다. 한 고객을 여러 탭에 넣을 수 있습니다(예: 유튜브유입 + 집중관리).</p>
				<table class="table type-input">
					<colgroup>
						<col width="18%" />
						<col />
					</colgroup>
					<tr>
						<th>새 탭</th>
						<td>
							<div class="form-wrap">
								<input
									class="form-control"
									type="text"
									maxlength="20"
									placeholder="예: 집중관리"
									v-model="newTabName"
									@keyup.enter="btnTabAdd"
								/>
								<button type="button" class="btn btn-sm btn-primary" :disabled="busy" @click="btnTabAdd">추가</button>
							</div>
						</td>
					</tr>
				</table>
				<table class="table ua-tabedit">
					<colgroup>
						<col width="10%" />
						<col />
						<col width="12%" />
						<col width="24%" />
					</colgroup>
					<tr>
						<th>순서</th>
						<th>탭 이름</th>
						<th>고객</th>
						<th></th>
					</tr>
					<tr v-for="(t, i) in editTabs" :key="'et_' + t.tab_uid">
						<td>
							<button type="button" class="btn ua-mv" :disabled="i === 0 || busy" title="위로" @click="moveTab(i, -1)">
								<b-icon-chevron-up />
							</button>
							<button
								type="button"
								class="btn ua-mv"
								:disabled="i === editTabs.length - 1 || busy"
								title="아래로"
								@click="moveTab(i, 1)"
							>
								<b-icon-chevron-down />
							</button>
						</td>
						<td>
							<input class="form-control" type="text" maxlength="20" v-model="t.edit" @keyup.enter="btnTabRename(t)" />
						</td>
						<td>{{ t.cnt }}명</td>
						<td>
							<button
								type="button"
								class="btn btn-xxsm btn-secondary"
								:disabled="busy || t.edit === t.tab_name"
								@click="btnTabRename(t)"
							>
								이름 저장
							</button>
							<button type="button" class="btn btn-xxsm btn-red" :disabled="busy" @click="btnTabDelete(t)">삭제</button>
						</td>
					</tr>
					<tr v-if="!editTabs.length">
						<td colspan="4">만든 탭이 없습니다.</td>
					</tr>
				</table>
				<div class="btn-wrap">
					<button type="button" class="btn btn-sm btn-secondary" @click="closeTabEdit">닫기</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { holdBadge } from '@/utils/clientManage.mjs';
import { formatPhone } from '@/utils/phone.mjs';

// 정렬 선택은 이 브라우저에 기억한다(직원 편의). 저장소가 막힌 환경에서도 화면은 기본값으로 뜬다.
const SORT_KEY = 'weonus.userAdmin.sort';
function readSort() {
	try {
		const v = window.localStorage.getItem(SORT_KEY);
		return v === 'hold' ? 'hold' : 'reg';
	} catch (e) {
		return 'reg';
	}
}
function writeSort(v) {
	try {
		window.localStorage.setItem(SORT_KEY, v);
	} catch (e) {
		/* 저장소가 막혀 있으면 이번 화면에서만 유지 */
	}
}

export default {
	name: 'UserAdmin',
	components: {},
	data() {
		return {
			// CZ: 자동보류 일수·알림 시점(관리자 설정). 목록 응답이 준다.
			holdCfg: { days: 30, alertDays: 7 },
			itemList: [],
			memList: [],
			menuType: 1,
			loaded: false,
			busy: false,

			// CS: 개인 탭·핀·정렬
			listSeq: 0,
			myTabs: [],
			tabUid: null,
			selected: [],
			assignTabUid: '',
			sort: readSort(),
			isTabEditShow: false,
			editTabs: [],
			newTabName: '',
			// CY: 서버가 목록과 함께 주는 내 열람범위(level, memUids, teamUnassigned)
			listScope: null,

			page: 1,
			pageData: null,
			totalCount: null,
			itemSize: 20,
			blockSize: 5,

			isRegisterPopupShow: false,
			isDetailPopupShow: false,

			st: true,
			searchOptions: {
				clientType: 'manage,contract',
				clientName: '',
				clientMobile: '',
				clientMoneyS: '',
				clientMoneyE: '',
				clientLevel: ['A', 'B', 'C'],
				mId: '',
			},

			searchOptions_: {
				clientType: 'manage,contract',
				clientName: '',
				clientMobile: '',
				clientMoneyS: '',
				clientMoneyE: '',
				clientLevel: ['A', 'B', 'C'],
				mId: '',
			},

			addInfo: {
				mgrUid: '',
				mgrLevel: 'C',
				clientType: '',
				clientName: '',
				clientMobile1: '',
				clientMobile2: '',
				clientMobileMemo1: '',
				clientMobileMemo2: '',
				clientEmail: '',
				clientMemo: '',
				findMoneyS: 0,
				findMoneyE: 0,
				havingMoney: 0,
				findArea: '',
			},
		};
	},
	updated() {},
	computed: {
		// 제휴기관 게스트(신한/대신) — 담당자 선택/연락처/고객구분 일부를 숨기는 분기 기준.
		isPartnerGuest() {
			return this.$store.getters.getPartnerGuest;
		},
		selfMemUid() {
			return this.$store.getters.getUserInfo.mem_uid;
		},
		// 담당자 필터는 내 범위의 직원만 고른다(일반 직원은 본인, 팀장은 팀원). 범위 밖 직원을 고르면 늘 빈 목록이다.
		memFilterList() {
			const sc = this.listScope;
			if (!sc || sc.level === 'all' || !Array.isArray(sc.memUids)) return this.memList;
			const ids = new Set(sc.memUids.map(Number));
			return this.memList.filter(m => ids.has(Number(m.mem_uid)));
		},
		// 버튼 노출만 가른다. 실제 권한은 서버가 DB 의 mem_type 으로 다시 본다.
		isMaster() {
			return !this.isPartnerGuest && this.$store.getters.getUserInfo.mem_type === 'master';
		},
		allChecked() {
			return this.itemList.length > 0 && this.itemList.every(i => this.selected.includes(i.client_uid));
		},
		tabNameMap() {
			const m = {};
			for (const t of this.myTabs) m[t.tab_uid] = t.tab_name;
			return m;
		},
		emptyText() {
			if (!this.tabUid) return '조건에 맞는 고객이 없습니다.';
			// 칩의 숫자는 검색 조건 없이 센 수라, 담긴 고객이 있는데 조건에 걸려 비는 경우를 구분한다.
			const t = this.myTabs.find(x => x.tab_uid === this.tabUid);
			return t && Number(t.cnt) > 0
				? '이 탭의 고객 중 조건에 맞는 고객이 없습니다.'
				: '이 탭에 담긴 고객이 없습니다. 목록에서 고객을 고른 뒤 탭에 넣으세요.';
		},
	},
	created() {
		if (Object.prototype.hasOwnProperty.call(this.$route.query, 'userId')) {
			this.searchOptions.mId = this.$route.query.userId;
			this.searchOptions_.mId = this.$route.query.userId;
		}

		this.getItemList(1);
		this.getMyTabs();
		// 게스트는 직원 명단(/setting/etc/mem) 접근 권한이 없고(담당자=본인 고정) 담당자 필터도 숨김.
		if (!this.isPartnerGuest) {
			this.getMemList();
		}
	},
	methods: {
		// 연락처 칸 자동 하이픈(CU). 임대고객 화면과 같은 규칙이다. v-model 대신 직접 쓰는 이유: 지운 글자가
		// 값을 바꾸지 않으면(예: 숫자 뒤에 문자 입력) 화면이 다시 그려지지 않아 입력칸에 그대로 남는다.
		onPhoneInput(e, key) {
			const v = formatPhone(e.target.value);
			e.target.value = v;
			this.addInfo[key] = v;
		},
		// 목록·상세 이동이 같은 조건을 쓰도록 한 곳에서 만든다. 개인 탭을 고르면 고객구분은 비운다
		// (탭은 고객구분과 나란한 보기라 미관리·계약 고객도 그 탭에 담겨 있으면 나와야 한다).
		listQuery() {
			return (
				'clientType=' +
				(this.tabUid ? '' : this.searchOptions.clientType) +
				'&clientName=' +
				this.searchOptions.clientName +
				'&clientMobile=' +
				this.searchOptions.clientMobile +
				'&clientMoneyS=' +
				this.searchOptions.clientMoneyS +
				'&clientMoneyE=' +
				this.searchOptions.clientMoneyE +
				'&clientLevel=' +
				this.searchOptions.clientLevel +
				'&mId=' +
				this.searchOptions.mId +
				'&sort=' +
				this.sort +
				'&tabUid=' +
				(this.tabUid || '')
			);
		},
		getItemList(pg) {
			// 탭·정렬을 빨리 바꾸면 늦게 온 앞 요청이 지금 조건의 목록을 덮는다. 마지막 요청의 답만 쓴다.
			const seq = ++this.listSeq;
			this.$apiGET('/admin/api/user/admin?' + this.listQuery() + '&page=' + (pg - 1) * this.itemSize).then(data => {
				if (seq !== this.listSeq) return;
				if (!data || !data.item) return;
				// 마지막 쪽의 고객을 전부 탭에서 빼면 그 쪽이 빈다. 앞 쪽에 고객이 남아 있으면 그 마지막 쪽으로 간다.
				const total = Number(data.pageInfo && data.pageInfo.totalCount) || 0;
				if (!data.item.length && pg > 1 && total > 0) {
					this.getItemList(Math.ceil(total / this.itemSize));
					return;
				}
				this.itemList = data.item;
				this.listScope = data.scope || null;
				if (data.hold) this.holdCfg = data.hold;
				// 다시 받은 목록에 남아 있는 고객은 선택을 유지한다(핀을 눌러도 탭에 넣으려고 고른 것이 풀리지 않게).
				const ids = new Set(data.item.map(i => i.client_uid));
				this.selected = this.selected.filter(id => ids.has(id));
				this.loaded = true;
				// 고객 카드에서 새로 만든 탭은 이 창이 아직 모른다. 모르는 탭이 보이면 탭 목록을 다시 받는다.
				if (data.item.some(i => (i.tabs || []).some(t => !this.tabNameMap[t]))) this.getMyTabs();

				this.totalCount = data.pageInfo.totalCount;
				this.page = pg;
				this.pageData = this.$pageDataSetting(this.totalCount, this.itemSize, this.blockSize, this.page);
			});
		},
		getMyTabs() {
			return this.$apiGET('/admin/api/user/admin/tab').then(data => {
				if (Array.isArray(data)) this.myTabs = data;
			});
		},
		tabName(tid) {
			return this.tabNameMap[tid] || '';
		},
		knownTabs(item) {
			return (item.tabs || []).filter(t => this.tabNameMap[t]);
		},
		badge(item) {
			return holdBadge({
				dday: item.hold_dday,
				exemptReason: item.hold_exempt_reason,
				exemptReasonName: item.hold_exempt_reason_name,
				exemptMemo: item.hold_exempt_memo,
				baseDate: item.hold_base_date,
				days: this.holdCfg.days,
				alertDays: this.holdCfg.alertDays,
			});
		},
		pickTab(tid) {
			this.tabUid = tid;
			this.getItemList(1);
		},
		changeSort(v) {
			if (this.sort === v) return;
			this.sort = v;
			writeSort(v);
			this.getItemList(1);
		},
		toggleAll(on) {
			this.selected = on ? this.itemList.map(i => i.client_uid) : [];
		},
		async togglePin(item) {
			const re = await this.$apiPOST('/admin/api/user/admin/pin', { cid: item.client_uid, on: !item.pinned });
			if (!re || !re.ok) return;
			// 고정은 순서를 바꾸므로 지금 쪽을 다시 받는다.
			this.getItemList(this.page);
		},
		async btnAssign(on) {
			if (!this.assignTabUid) {
				alert(this.myTabs.length ? '탭을 선택하세요.' : '먼저 탭 관리에서 탭을 만드세요.');
				return;
			}
			if (!this.selected.length) {
				alert('고객을 1명 이상 선택하세요.');
				return;
			}
			this.busy = true;
			try {
				const re = await this.$apiPOST('/admin/api/user/admin/tab/assign', {
					tabUid: this.assignTabUid,
					cids: this.selected,
					on,
				});
				if (!re || !re.ok) return;
				const name = this.tabName(this.assignTabUid);
				let msg = on ? `[${name}] 탭에 ${re.changed}명을 넣었습니다.` : `[${name}] 탭에서 ${re.changed}명을 뺐습니다.`;
				const already = this.selected.length - re.changed - (re.skipped || 0);
				if (on && already > 0) msg += `\n이미 들어 있던 고객 ${already}명은 그대로입니다.`;
				if (on && re.skipped > 0) msg += `\n내 목록 범위 밖 고객 ${re.skipped}명은 넣지 않았습니다.`;
				alert(msg);
				// 한 번 넣거나 뺀 선택은 끝난 일이다. 다음 작업이 같은 고객을 모르고 다시 건드리지 않게 비운다.
				this.selected = [];
				await this.getMyTabs();
				this.getItemList(this.page);
			} finally {
				this.busy = false;
			}
		},
		// ── 탭 관리 팝업 ──
		openTabEdit() {
			this.syncEditTabs();
			this.newTabName = '';
			this.isTabEditShow = true;
		},
		closeTabEdit() {
			this.isTabEditShow = false;
			this.getItemList(this.page);
		},
		syncEditTabs() {
			this.editTabs = this.myTabs.map(t => ({ ...t, edit: t.tab_name }));
		},
		async reloadTabs() {
			await this.getMyTabs();
			this.syncEditTabs();
		},
		async btnTabAdd() {
			const name = this.newTabName.trim();
			if (!name) {
				alert('탭 이름을 입력하세요.');
				return;
			}
			this.busy = true;
			try {
				const re = await this.$apiPOST('/admin/api/user/admin/tab/add', { name });
				if (!re || !re.ok) return;
				this.newTabName = '';
				await this.reloadTabs();
			} finally {
				this.busy = false;
			}
		},
		async btnTabRename(t) {
			const name = (t.edit || '').trim();
			if (!name || name === t.tab_name) return;
			this.busy = true;
			try {
				const re = await this.$apiPOST('/admin/api/user/admin/tab/update', { tabUid: t.tab_uid, name });
				if (!re || !re.ok) return;
				await this.reloadTabs();
			} finally {
				this.busy = false;
			}
		},
		async btnTabDelete(t) {
			const msg =
				t.cnt > 0
					? `[${t.tab_name}] 탭을 삭제합니다.\n담긴 고객 ${t.cnt}명은 탭에서만 빠지고 고객 정보는 그대로입니다.`
					: `[${t.tab_name}] 탭을 삭제합니다.`;
			if (!confirm(msg)) return;
			this.busy = true;
			try {
				const re = await this.$apiPOST('/admin/api/user/admin/tab/delete', { tabUid: t.tab_uid });
				if (!re || !re.ok) return;
				if (this.tabUid === t.tab_uid) this.tabUid = null;
				if (this.assignTabUid === t.tab_uid) this.assignTabUid = '';
				await this.reloadTabs();
			} finally {
				this.busy = false;
			}
		},
		async moveTab(i, dir) {
			const list = this.editTabs.slice();
			const j = i + dir;
			if (j < 0 || j >= list.length) return;
			[list[i], list[j]] = [list[j], list[i]];
			this.busy = true;
			try {
				const re = await this.$apiPOST('/admin/api/user/admin/tab/order', { tabUids: list.map(t => t.tab_uid) });
				if (!re || !re.ok) return;
				await this.reloadTabs();
			} finally {
				this.busy = false;
			}
		},
		// ── 자동보류 제외 관리(master, CY): 제외 현황·직원 한도·제외 사유는 시스템관리 화면에 있다 ──
		goHoldAdmin() {
			this.$router.push('/SystemAdmin/SystemAdmin18');
		},
		clearInfo() {
			this.searchOptions = {
				clientType: this.searchOptions.clientType,
				clientName: '',
				clientMobile: '',
				clientMoneyS: '',
				clientMoneyE: '',
				clientLevel: '',
				mId: '',
			};
		},
		changeMenu(menu) {
			this.tabUid = null;
			if (menu == 1) {
				this.searchOptions.clientType = this.$CLIENT_TYPE.MANAGE + ',' + this.$CLIENT_TYPE.CONTRACT;
			} else if (menu == 2) {
				this.searchOptions.clientType = this.$CLIENT_TYPE.NONE;
			} else if (menu == 3) {
				this.searchOptions.clientType = this.$CLIENT_TYPE.PROPERTY;
			} else if (menu == 4) {
				this.searchOptions.clientType = this.$CLIENT_TYPE.BLACK;
			}

			this.getItemList(1);
			this.menuType = menu;
		},
		btnStOption() {
			if (this.st) {
				this.searchOptions_.clientLevel = ['A', 'B', 'C'];
			} else {
				this.searchOptions_.clientLevel = [];
			}
		},
		btnSearch() {
			this.searchOptions_.clientType = this.searchOptions.clientType;
			this.searchOptions = JSON.parse(JSON.stringify(this.searchOptions_));
			this.getItemList(1);
		},
		getMemList() {
			this.$apiGET('/admin/api/setting/etc/mem').then(data => {
				// 실패하면 false 가 온다. 그대로 두면 담당자 필터(memFilterList)의 filter 가 터져 목록 화면 전체가 안 그려진다.
				this.memList = Array.isArray(data) ? data : [];
			});
		},
		btnOpenRegister() {
			// 게스트는 담당자 선택 UI 가 없으므로 본인(mem_uid)으로 고정하고(백엔드 검증 통과용 —
			// 실제 소유자는 서버가 JWT 로 강제), 숨긴 고객구분 기본값을 '관리'로 둔다.
			if (this.isPartnerGuest) {
				this.addInfo.mgrUid = this.selfMemUid;
				this.addInfo.clientType = 'manage';
			}
			this.isRegisterPopupShow = true;
		},
		btnUserAdd() {
			this.$apiPOST('/admin/api/user/admin/add', this.addInfo).then(data => {
				if (!data) {
					return;
				} else if (data.error) {
					const err = data.info;

					alert(
						'[' +
							this.$CLIENT_TYPE[err.client_type] +
							']\n[' +
							err.mgr_mem_name +
							'] 의 [' +
							err.name +
							'] 고객으로 이미 등록 되어있습니다.',
					);
				} else {
					this.getItemList(this.page);
					this.isRegisterPopupShow = false;
					alert('등록이 완료되었습니다.');
				}
			});
		},
		btnOnDetail(cid, idx) {
			let w = window.screen.availWidth;
			let h = window.screen.availHeight;

			let attr = 'width=' + w + ', height=' + h + ', resizable=no, status=no';

			// 상세 화면의 이전·다음 이동이 목록과 같은 조건·정렬(개인 탭·핀 포함)을 쓰도록 그대로 넘긴다.
			window.open(
				'/UserDetail/' +
					cid +
					'?' +
					this.listQuery() +
					'&idx=' +
					(idx + 1 + (this.page - 1) * this.itemSize) +
					'&totalCount=' +
					this.totalCount,
				'',
				attr,
			);
		},
	},
};
</script>

<style lang="scss">
// 값의 출처는 DESIGN.md 하나뿐이다. 색·간격을 숫자로 새로 만들지 않는다.
@import '@/assets/css/design-tokens.scss';

// 내 탭: 상단 고객구분 탭의 옆 보기. 탭바와 같은 모양을 두 줄 쌓지 않고 칩으로 한 단 낮춘다.
.ua-tabs {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 6px;
	margin-bottom: 12px;
	&--label {
		font-size: 12px;
		font-weight: 600;
		color: $dt-color-ink-muted;
		margin-right: 2px;
	}
	// bootstrap .btn 과 특이도가 같으면 로드 순서에 따라 배경이 덮인다(ContractAdmin 실측). 부모를 함께 쓴다.
	.ua-tabs--chip,
	.ua-tabs--edit {
		height: 24px;
		padding: 0 10px;
		font-size: 12px;
		line-height: 1;
		border: 1px solid $dt-color-line-strong;
		border-radius: $dt-rounded-full;
		background: $dt-color-canvas;
		color: $dt-color-ink-muted;
		&:hover {
			border-color: $dt-color-ink-faint;
			color: $dt-color-ink;
		}
		&.on {
			background: $dt-color-primary-ink;
			border-color: $dt-color-primary-ink;
			color: #fff;
		}
	}
	.ua-tabs--edit {
		background: $dt-color-surface;
		color: $dt-color-primary-ink;
	}
	&--cnt {
		font-size: 11px;
		margin-left: 4px;
		opacity: 0.75;
	}
	&--hint {
		font-size: 12px;
		color: $dt-color-ink-faint;
	}
}
.ua-bar {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 8px;
	white-space: nowrap;
	&--left,
	&--right {
		display: flex;
		align-items: center;
		gap: 6px;
	}
	&--sel,
	&--label {
		font-size: 12px;
		color: $dt-color-ink-muted;
	}
	&--sel {
		min-width: 64px;
	}
	// 공통 .form-control 의 위아래 패딩이 남은 채 높이만 줄이면 글자 아래가 잘린다(실측). 패딩을 걷고 줄 높이로 가운데 맞춘다.
	.form-control.select.sm {
		width: 150px;
		height: 30px;
		padding: 0 28px 0 10px;
		line-height: 28px;
		font-size: 13px;
		margin: 0;
	}
}
// 정렬 전환: 검색줄 안의 보기 전환은 서로 붙은 세그먼트로(DESIGN.md).
.ua-seg {
	display: inline-flex;
	border: 1px solid $dt-color-line-strong;
	border-radius: $dt-rounded-chip;
	overflow: hidden;
	.btn {
		height: 26px;
		padding: 0 10px;
		font-size: 12px;
		border: 0;
		border-radius: 0;
		background: $dt-color-surface;
		color: $dt-color-ink-muted;
		& + .btn {
			border-left: 1px solid $dt-color-line-strong;
		}
		&.on {
			background: $dt-color-primary-ink;
			color: #fff;
		}
	}
}
.ua-list {
	.ua-pinned td {
		background: $dt-color-surface-sunken;
	}
	.btn.ua-pin {
		padding: 0 4px;
		border: 0;
		color: $dt-color-ink-faint;
		font-size: 14px;
		&.on {
			color: $dt-color-primary-ink;
		}
		&:hover {
			color: $dt-color-ink;
		}
	}
	.ua-empty {
		color: $dt-color-ink-faint;
	}
}
// 아래 배지들은 표 칸(td) 바로 안의 span 이다. bootstrap 의 `.table>:not(caption)>*>*` 셀 규칙(0,1,1)이
// tbody 없는 Vue 표에서는 td 의 자식 span 에 8px 패딩을 입히므로(메모: bootstrap 표 인라인 오염),
// 표 이름을 앞에 붙여(0,2,0) 이 규칙을 이긴다.
// 고객명 옆 탭 꼬리표: 배경 없이 1px 테두리 + 11px(DESIGN.md 역할·상태 배지).
.ua-list .ua-chip {
	display: inline-block;
	margin-left: 4px;
	padding: 0 5px;
	font-size: 11px;
	line-height: 16px;
	color: $dt-color-ink-muted;
	border: 1px solid $dt-color-line-strong;
	border-radius: $dt-rounded-chip;
	white-space: nowrap;
}
// 자동보류 D-day. 색의 의미는 DESIGN.md 에 고정: 빨강 = 기한 초과·임박, 주황 잉크 = 주의.
.ua-dday-cell {
	white-space: nowrap;
}
.ua-list .ua-dday {
	display: inline-block;
	min-width: 44px;
	padding: 0 5px;
	font-size: 12px;
	line-height: 18px;
	border: 1px solid transparent;
	border-radius: $dt-rounded-chip;
	&.is-normal {
		color: $dt-color-ink;
	}
	&.is-soon {
		color: $dt-color-warning-ink;
		border-color: $dt-color-warning;
		font-weight: 600;
	}
	&.is-urgent,
	&.is-over {
		color: $dt-color-danger;
		border-color: $dt-color-danger;
		font-weight: 600;
	}
	&.is-exempt {
		color: $dt-color-ink-muted;
		border-color: $dt-color-line-strong;
	}
	&.is-none {
		color: $dt-color-ink-faint;
	}
	&--sub {
		margin-left: 3px;
		font-size: 11px;
		color: $dt-color-ink-faint;
	}
}
.ua-help {
	font-size: 12px;
	line-height: 1.6;
	color: $dt-color-ink-faint;
	margin-bottom: 10px;
}
.ua-tabedit {
	margin-top: 10px;
	.form-control {
		height: $dt-spacing-control-height;
		font-size: 13px;
	}
	.btn.ua-mv {
		padding: 0 4px;
		border: 0;
		font-size: 13px;
	}
	.btn-xxsm + .btn-xxsm {
		margin-left: 4px;
	}
}
.ua-scope-note {
	margin: 0 0 8px;
	font-size: 12px;
	color: $dt-color-warning-ink;
}
</style>
